import { type PosProduct } from "~/types/product";

type HybridBillingDiscount = PosProduct["discount"];

export function shouldShowListStrikethrough(
  discount: HybridBillingDiscount
): boolean {
  return Boolean(
    discount &&
      !discount.isAllowanceOver &&
      discount.type === "discount-hybridBilling" &&
      discount.allowanceType !== "unitPrice"
  );
}

type ShouldShowBasketStrikethroughArgs = {
  discount: HybridBillingDiscount;
  discountPercentage?: number;
  hasOrderDiscount: boolean;
};

export function shouldShowBasketStrikethrough({
  discount,
  discountPercentage,
  hasOrderDiscount
}: ShouldShowBasketStrikethroughArgs): boolean {
  const hasHybridBillingDiscountLabel = Boolean(discount?.amount);
  const hasPosDiscountLabel = Boolean(discountPercentage && !hasOrderDiscount);

  return hasHybridBillingDiscountLabel || hasPosDiscountLabel;
}

export function getBasketDisplayDiscounts({
  discount,
  discountPercentage,
  hasOrderDiscount,
  posDiscountLabel
}: ShouldShowBasketStrikethroughArgs & {
  posDiscountLabel: string;
}): { name: string; percentage: number }[] {
  const displayDiscounts: { name: string; percentage: number }[] = [];

  if (discount?.amount) {
    displayDiscounts.push({
      name: discount.name,
      percentage: discount.percentage
    });
  }

  if (discountPercentage && !hasOrderDiscount) {
    displayDiscounts.push({
      name: posDiscountLabel,
      percentage: discountPercentage
    });
  }

  return displayDiscounts;
}
